/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, DestroyRef, computed, effect, inject, input, signal } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ChatContent } from '../../models/chat.model';
import {
    DEFAULT_TABLE_SORT,
    TableSortState,
    applyTableSort,
    nextTableSortState,
    tableSortAria,
    tableSortIcon
} from '../../utils/table-sort.util';

/**
 * Content Renderer Component
 * 
 * Renders chat message content with optional word-by-word streaming animation.
 * Supports various content types: text, markdown, code, tables, and lists.
 * 
 * @example
 * <app-content-renderer 
 *   [content]="messageContent"
 *   [isBotMessage]="true"
 *   [enableStreaming]="true"
 *   [streamingSpeed]="50">
 * </app-content-renderer>
 */
@Component({
    selector: 'app-content-renderer',
    templateUrl: './content-renderer.component.html',
    styleUrl: './content-renderer.component.scss',
    standalone: false
})
export class ContentRendererComponent {
    private readonly sanitizer = inject(DomSanitizer);
    private readonly destroyRef = inject(DestroyRef);

    /** Content object to render */
    readonly content = input.required<ChatContent>();

    /** Enable/disable streaming animation */
    readonly enableStreaming = input(true);

    /** Controls if chat-level streaming is enabled */
    readonly enableChatStreaming = input(false);

    /** Speed of word streaming in milliseconds */
    readonly streamingSpeed = input(50);

    /** Identifies if this is a bot message (for streaming logic) */
    readonly isBotMessage = input(false);

    /** Currently displayed text during streaming */
    displayedText: string = '';

    /** Indicates if streaming is currently active */
    isStreaming: boolean = false;

    /** Indicates if streaming has completed */
    streamingComplete: boolean = false;

    /** Timeout reference for streaming animation */
    private streamingTimeout: any;

    /** Current word index during streaming */
    private currentWordIndex: number = 0;

    /** Full text before streaming */
    private fullText: string = '';

    /** Array of words to stream */
    private words: string[] = [];

    /** Reactive sort state for the current table content (column index + direction). */
    private readonly tableSort = signal<TableSortState>(DEFAULT_TABLE_SORT);

    /** Rows of the current table sorted according to the current sort state. */
    readonly sortedTableRows = computed<string[][]>(() => {
        const data = this.content()?.data;
        const rows: string[][] = Array.isArray(data?.rows) ? data.rows : [];
        return applyTableSort(rows, this.tableSort());
    });

    constructor() {
        // Register cleanup on destroy
        this.destroyRef.onDestroy(() => {
            this.stopStreaming();
        });

        // React to content changes
        effect(() => {
            const contentValue = this.content();
            if (contentValue) {
                this.initializeStreaming();
            }
        });
    }

    /**
     * Initialize word-by-word streaming display for bot messages
     */
    private initializeStreaming(): void {
        // Only apply streaming for bot messages, not user messages
        const shouldStream = this.enableStreaming() &&
            this.isBotMessage() && this.enableChatStreaming() &&
            this.content() &&
            (this.content().type === 'text' || this.content().type === 'markdown' || this.content().type === 'code');

        if (!shouldStream) {
            this.displayedText = this.getContentText();
            this.streamingComplete = true;
            return;
        }

        this.stopStreaming();
        this.fullText = this.getContentText();
        this.words = this.splitIntoWords(this.fullText);
        this.displayedText = '';
        this.currentWordIndex = 0;
        this.isStreaming = true;
        this.streamingComplete = false;
        this.startStreaming();
    }

    /**
     * Start word-by-word streaming
     */
    private startStreaming(): void {
        if (this.currentWordIndex < this.words.length) {
            // Add space before word (except for the first word)
            if (this.currentWordIndex > 0) {
                this.displayedText += ' ';
            }

            this.displayedText += this.words[this.currentWordIndex];
            this.currentWordIndex++;

            this.streamingTimeout = setTimeout(() => {
                this.startStreaming();
            }, this.streamingSpeed());
        } else {
            this.completeStreaming();
        }
    }

    /**
     * Complete streaming display
     */
    private completeStreaming(): void {
        this.isStreaming = false;
        this.streamingComplete = true;
        this.displayedText = this.fullText;
    }

    /**
     * Stop current streaming process
     */
    private stopStreaming(): void {
        if (this.streamingTimeout) {
            clearTimeout(this.streamingTimeout);
            this.streamingTimeout = null;
        }
        this.isStreaming = false;
    }

    /**
     * Get text content for streaming
     */
    private getContentText(): string {
        const contentValue = this.content();
        if (!contentValue) return '';

        switch (contentValue.type) {
            case 'text':
            case 'markdown':
                return contentValue.data || '';
            case 'code':
                return contentValue.data || '';
            default:
                return '';
        }
    }

    /**
     * Split text into words while preserving line breaks and formatting
     */
    private splitIntoWords(text: string): string[] {
        if (!text) return [];

        // Simple word splitting that preserves punctuation with words
        return text.split(/\s+/).filter(word => word.length > 0);
    }

    /**
     * Check if streaming should be applied for current content
     */
    shouldApplyStreaming(): boolean {
        const contentValue = this.content();
        return this.enableStreaming() &&
            this.isBotMessage() &&
            contentValue &&
            (contentValue.type === 'text' || contentValue.type === 'markdown' || contentValue.type === 'code');
    }

    /**
     * Check if data is in table format
     * @param data - Data to check
     * @returns True if data has table structure
     */
    isTableData(data: any): boolean {
        return data && typeof data === 'object' && data.headers && data.rows;
    }

    /**
     * Check if data is in list format
     * @param data - Data to check
     * @returns True if data has list structure
     */
    isListData(data: any): boolean {
        return data && typeof data === 'object' && data.items && Array.isArray(data.items);
    }

    /**
     * Format text with markdown-like syntax
     * Converts **bold**, *italic*, `code`, and newlines to HTML
     * 
     * @param text - Text to format
     * @returns Formatted HTML string
     */
    formatText(text: string): string {
        if (!text) return '';

        // Check if text contains HTML table tags
        if (text.includes('<table') && text.includes('</table>')) {
            // Return HTML as-is for tables
            return text;
        }

        // Simple markdown-like formatting for regular text
        return text
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold
            .replace(/\*(.*?)\*/g, '<em>$1</em>') // Italic
            .replace(/`(.*?)`/g, '<code>$1</code>') // Inline code
            .replace(/\n/g, '<br>'); // Line breaks
    }

    /**
     * Copy text to clipboard
     * Uses modern Clipboard API if available
     * 
     * @param text - Text to copy
     */
    copyToClipboard(text: string): void {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(() => {
                // Could show a toast notification here
                console.log('Copied to clipboard');
            }).catch(err => {
                console.error('Failed to copy: ', err);
            });
        }
    }

    /**
     * Safely sanitize HTML content for rendering
     */
    getSafeHtml(htmlContent: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
    }

    /**
     * Additional methods for table rendering support
     */
    getTableDataSource(): any[] {
        const contentValue = this.content();
        if (!this.isTableData(contentValue.data)) return [];

        return contentValue.data.rows.map((row: string[]) => {
            const rowObj: any = {};
            contentValue.data.headers.forEach((header: string, index: number) => {
                rowObj[`col_${index}`] = row[index] || '';
            });
            return rowObj;
        });
    }

    getTableColumns(): string[] {
        const contentValue = this.content();
        if (!this.isTableData(contentValue.data)) return [];

        return contentValue.data.headers.map((_: string, index: number) => `col_${index}`);
    }

    getTableAsText(): string {
        const contentValue = this.content();
        if (!this.isTableData(contentValue.data)) return '';

        const headerRow = contentValue.data.headers.join('\t');
        const dataRows = contentValue.data.rows.map((row: string[]) => row.join('\t'));
        return [headerRow, ...dataRows].join('\n');
    }

    onTableHeaderSort(colIndex: number): void {
        const nextSortState = nextTableSortState(this.tableSort(), colIndex);
        this.tableSort.set(nextSortState);
    }

    getTableSortIcon(colIndex: number): string {
        return tableSortIcon(this.tableSort(), colIndex);
    }

    getTableSortAria(colIndex: number): 'ascending' | 'descending' | 'none' {
        return tableSortAria(this.tableSort(), colIndex);
    }
}